import { AcademyFormComponent } from "Components/Shared";

const EditAcademy = () => {
  return <AcademyFormComponent isEditAcademy={true} />;
};

export default EditAcademy;
